import { ApiService, encodeQueryData, SERVICES } from './BaseService';

export const NotificationService = {
    getMyNotifications: (data: any) => {
        return ApiService(SERVICES.CONNECTOR_BACKEND).get(`notifications/me?${encodeQueryData(data)}`);
    },
    markAsSeen: (notificationId: number) => {
        return ApiService(SERVICES.CONNECTOR_BACKEND).post(`notifications/${notificationId}/seen`);
    }
}